import React from 'react';
import { DollarSign, Lock } from 'lucide-react';
import { PRIVATE_PAYOUT_EXCLUDED_NOTE } from '../../../utils/bookingSource';

const RevenueBreakdown = ({ revenueAnalytics = {}, overview = {} }) => {
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '$0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '$0.00';
    return `$${numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const platformRevenue =
    revenueAnalytics.platform_revenue ??
    overview.platform_revenue ??
    revenueAnalytics.total_revenue ??
    overview.total_revenue ??
    0;
  const privateOffline =
    revenueAnalytics.private_offline_collected ?? overview.private_offline_collected ?? 0;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-1">Revenue Breakdown</h2>
      <p className="text-xs text-gray-500 mb-4">Platform totals exclude private offline bookings</p>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div>
            <p className="text-sm text-gray-600">Platform revenue</p>
            <p className="text-xl font-bold text-gray-900 mt-1">{formatCurrency(platformRevenue)}</p>
            <p className="text-xs text-gray-500 mt-0.5">Collected via platform payments</p>
          </div>
          <DollarSign className="w-8 h-8 text-green-600" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Platform fees</p>
            <p className="text-lg font-semibold text-gray-900">
              {formatCurrency(revenueAnalytics.platform_fees || overview.platform_fees || 0)}
            </p>
          </div>
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Vendor payouts</p>
            <p className="text-lg font-semibold text-gray-900">
              {formatCurrency(revenueAnalytics.vendor_payouts || 0)}
            </p>
          </div>
        </div>
        {privateOffline > 0 && (
          <div className="flex items-center justify-between p-3 bg-indigo-50 border border-indigo-100 rounded-lg">
            <div>
              <p className="text-sm text-indigo-800 font-medium">Private offline collected</p>
              <p className="text-lg font-semibold text-indigo-900 mt-1">{formatCurrency(privateOffline)}</p>
              <p className="text-xs text-indigo-600 mt-0.5">{PRIVATE_PAYOUT_EXCLUDED_NOTE}</p>
            </div>
            <Lock className="w-7 h-7 text-indigo-500 shrink-0" />
          </div>
        )}
        {revenueAnalytics.average_transaction > 0 && (
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-600 mb-1">Avg platform transaction</p>
            <p className="text-lg font-semibold text-gray-900">
              {formatCurrency(revenueAnalytics.average_transaction)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenueBreakdown;
